import { render } from "./HomeImage.vue?vue&type=template&id=bd609906&scoped=true"
import script from "./HomeImage.vue?vue&type=script&lang=js"
export * from "./HomeImage.vue?vue&type=script&lang=js"

import "./HomeImage.vue?vue&type=style&index=0&id=bd609906&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd609906"]])

export default __exports__